import { createContext, useContext } from 'react'

export interface RouteContext {
	tenantId?: string
	orgId?: string
}

// Component-free module keeps this context's identity stable across Fast Refresh;
// co-locating it with a component export makes HMR mint a new context and desync the provider.
export const RouteContext = createContext<RouteContext | null>(null)

export function useRouteContext(): RouteContext {
	const context = useContext(RouteContext)
	if (!context) {
		throw new Error('useRouteContext must be used within RouteContextLayout')
	}
	return context
}
